import { IconBack } from '../../../../assets/index';
import ButtonLoginViaGGFB from '../../../../components/login/ButtonLoginViaGGFB';
import * as React from 'react';
import { useEffect, useState } from 'react';
import RegisterStep1 from './components/RegisterStep1';
import RegisterStep2 from './components/RegisterStep2';
import RegisterStep3 from './components/RegisterStep3';
import './MobileRegister.scss';
import { useHistory } from 'react-router-dom';
import { isAuthenticate } from '../../../../utils/helpers/helpers';
import { routes } from '../../../../utils/constants/constant';

const MobileRegister = (props) => {
  const [step, setStep] = useState(1);
  const [dataForm, setDataForm] = useState({});
  const history = useHistory();
  useEffect(() => {
    setStep(1);
  }, []);

  const handleChangeStep = (valueStep = 1) => {
    setStep(valueStep);
  };

  const handleChangeDataForm = (data = {}) => {
    setDataForm(data);
  };

  const handleBack = () => {
    step !== 1 ? setStep(step - 1) : history.goBack();
  };
  if (isAuthenticate()) {
    history.push(routes.DASHBOARD);
    return null;
  }
  return (
    <div className='mobile-register'>
      {/* {step !== 1 && ( */}
      <div className='btn-back' onClick={handleBack}>
        <div className='icon-back'>
          <IconBack />
        </div>
        Đăng ký
      </div>
      {/* )} */}
      {step === 1 && (
        <>
          <ButtonLoginViaGGFB isLogin={false} />
          <div className='text-des'>Hoặc đăng ký bằng số điện thoại</div>
        </>
      )}
      {step === 1 ? (
        <RegisterStep1
          handleChangeStep={handleChangeStep}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      ) : step === 2 ? (
        <RegisterStep2
          handleChangeStep={handleChangeStep}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      ) : (
        <RegisterStep3
          handleChangeStep={handleChangeStep}
          dataForm={dataForm}
          handleChangeDataForm={handleChangeDataForm}
        />
      )}
    </div>
  );
};

export default MobileRegister;
